import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders, HttpParams } from '@angular/common/http';
import { url } from 'src/app/config/config';
import { map } from 'rxjs/operators';



@Injectable({
  providedIn: 'root'
})
export class ImprimiService {
    public myurl = url+"informes/";


    constructor(private http:HttpClient) {
      
     }
     getId(id,base){
      
       
        let headers = new HttpHeaders();
        let body = JSON.stringify([{"id":id}]);

        // console.log('myurl',this.myurl);
        // 
        // console.log('base',base);
        
        console.log(this.myurl, base)
        
        headers.append('Content-Type' , 'application/json');
        return this.http.post(this.myurl+""+base+"Id.php",body,{headers:headers}).pipe(map(res=>{
           return res;
         }));
       }

       /**
        * Con este método recogemos
        * el anexo anterior y revisión.
        * @param fecha 
        * @param base 
        */
       getAnexo( fecha, base){
        let headers=new HttpHeaders();
        let body=JSON.stringify({"fecha":fecha,"categoria":base});
       
        headers.append('Content-Type' , 'application/json');
        return this.http.post(url+"categoria/fechaAnexoAnterior.php",body,{headers:headers}).pipe(map(res=>{
          
           return res;
         }));
       }
}
